<div class="calculator">
  <mat-accordion>
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="cal_header">
          Premium Details
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="cal_body p-3 bg-white">
        <p>
          <b>Policy premium</b><br>{{ showPremiumAsTbc ? 'TBC' : ('£' + ((premiumDetails?.policy_premium || 0) | premiumPenceUp | number:'1.2-2')) }}
        </p>
        <p>
          <b>Insurance premium tax (12%)</b><br>{{ showPremiumAsTbc ? 'TBC' : ('£' + ((premiumDetails?.ipt != null ? premiumDetails?.ipt : 0) | premiumPenceUp | number:'1.2-2')) }}
        </p>
        <p>
          <b>Total premium</b><br>{{ showPremiumAsTbc ? 'TBC' : ('£' + ((premiumDetails?.total_premium || 0) | premiumPenceUp | number:'1.2-2')) }}
        </p>
        <p>
          <b>Fees</b><br>{{ showPremiumAsTbc ? 'TBC' : ('£' + ((premiumDetails?.uw_fee || 0) | premiumPenceUp | number:'1.2-2')) }}
        </p>
        <p>
          <b>Total cost of the policy</b><br>{{ showPremiumAsTbc ? 'TBC' : ('£' + ((premiumDetails?.total_payable_amount || 0) | premiumPenceUp | number:'1.2-2')) }}
        </p>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="btn btn-default btn-gray mt-2 w-100 text-left" *ngIf="quoteInfo?.quote_ref_number">
    Quote Reference: {{ quoteInfo.quote_ref_number }}
  </div>
</div>
